// src/components/KPICard.jsx
import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const KPICard = ({ title, value, trend = "up", color = "green" }) => {
  return (
    <div
      className="group relative overflow-hidden hover:scale-105 transition-all duration-300"
      style={{
        width: "100%",
        maxWidth: "250px",
        height: "110px",
        borderRadius: "10px",
        background:
          "linear-gradient(252.82deg, rgba(217, 217, 217, 0.025) 25.41%, rgba(115, 108, 207, 0.005) 115.2%)",
        backdropFilter: "blur(75px)",
      }}
    >
      {/* Hover glow */}
      <div
        className={`absolute inset-0 bg-gradient-to-br from-${color}-500/5 to-transparent 
                    opacity-0 group-hover:opacity-100 transition-opacity duration-300`}
      />

      <div className="relative z-10 p-10 p-4 flex flex-col justify-between h-full">
        <p className="text-[#D3B4FF] text-base font-light">{title}</p>
        <div className="flex items-end justify-between">
          <div className="text-3xl font-extrabold text-gray-400">
            {value ?? 0}
          </div>
          {/* {trend === "up" && <TrendingUp className="text-green-400 w-6 h-6 mb-1" />}
          {trend === "down" && <TrendingDown className="text-red-400 w-6 h-6 mb-1" />} */}
        </div>
      </div>
    </div>
  );
};

export default KPICard;